import { MotifMailCategorie } from '@common/services';

export const MOTIF_MAIL_CATEGORIE_TEXTS: Record<MotifMailCategorie, string> = {
  [MotifMailCategorie.REFUS]: 'Refus',
  [MotifMailCategorie.DEMANDE_INFORMATION]: 'Demande d\'information',
  [MotifMailCategorie.RELANCE]: 'Contact',
};